import { sendAnalytics } from '@audio-network/analytics'

import { addToCart } from '@/services/cartService'
import { redirectToHref } from '@/utils/window'

export const handleLicenseClick = async (
	trackId: number,
	source: string
): Promise<void> => {
	const updatedCart = await addToCart(trackId)

	if (updatedCart) {
		sendAnalytics({
			noun: 'License Track',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				TrackSource: source,
			},
		})
		redirectToHref('/licensing')
	}
}
